import { usePostHog } from '@/composables/usePostHog'

// usePostHog() initialises posthog each time it is called, so do it once.
let client = null

export function track(name, props) {
  try {
    if (!client) client = usePostHog().posthog
    client.capture(name, props)
  } catch (e) {
    // analytics must never break the flow
  }
}
